import { memo, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { PuffMeetoor, PropaMeetoor } from '../../../../main/loadshap/loadshap';
import ScrollBar from '../../../../main/scrollbar';
import Actions from "../../../../reducer/actions";
import { fetchFollowSuggestions } from '../../../../main/suggestGraphql';
import {
    coreCancelFriendRequestToUserMutation,
    coreFollowUserMutation,
    coreUnfollowUserMutation,
    removeFriendApi,
    sendFriendRequestApi,
} from '../../../../main/socialGraphql';
import { JobSvg, SecureSvg, AskFriendSvg, FollowersSvg, CloseSvg, DeleteSvg } from '../../icons/icons';
import { compactNumber } from '../../../../main/locale';
///////////////////////////////////////////////////////
const BlockOuter = ({ name, username, photo, infos, userid, setHold,
    hold, isOwner, isSecure, followState, isfriend = false }) => {
    const { meetoorOwner, branchText, buttons, badges, messages } = useSelector(state => state.sign.langData);
    const lang = useSelector(state => state.sign.lang);
    const token = useSelector(state => state.sign.token);
    const dispatch = useDispatch();
    ///////////////////////////////////////////////////////
    const updateRow = (callback) => dispatch(Actions.type("setSuggestFollowers", {
        type: 'update', data: { target: userid, key: 'userid', callback }
    }));
    ///////////////////////////////////////////////////////
    const addFollow = async () => {
        const isFollowing = !!followState;
        setHold(true);
        updateRow((target) => {
            target.followState = <span className="propa">
                <PropaMeetoor size={5} loading={true} clr="lit" />
            </span>
        });
        try {
            const payload = isFollowing
                ? await coreUnfollowUserMutation(token, username)
                : await coreFollowUserMutation(token, username);
            const ok = !!payload?.ok;
            updateRow((target) => {
                const nowFollowing = ok ? !isFollowing : isFollowing;
                target.followState = nowFollowing
                    ? <><FollowersSvg className="lit" /> {buttons.following}</>
                    : undefined;
                if (ok) target.infos.followers += isFollowing ? -1 : 1;
            });
        } catch (e) {
            console.log("suggest follow -> follow", e);
            updateRow((target) => { target.followState = isFollowing ? followState : undefined; });
        } finally {
            setHold(false);
        }
    }
    ///////////////////////////////////////////////////////
    /** false → send request, "sent" → cancel it, true → unfriend. */
    const addFriend = async () => {
        const previous = isfriend;
        setHold(true);
        updateRow((target) => { target.isfriend = "propa"; });
        try {
            let next = previous;
            if (previous === false) {
                const data = await sendFriendRequestApi(token, username);
                if (data?.sendFriendRequest?.ok) next = "sent";
            } else if (previous === "sent") {
                const payload = await coreCancelFriendRequestToUserMutation(token, username);
                if (payload?.ok) next = false;
            } else if (previous === true) {
                const data = await removeFriendApi(token, username);
                if (data?.removeFriend?.ok) next = false;
            }
            updateRow((target) => { target.isfriend = next; });
        } catch (e) {
            console.log("suggest follow -> friend request", e);
            updateRow((target) => { target.isfriend = previous; });
        } finally {
            setHold(false);
        }
    }
    ///////////////////////////////////////////////////////
    return (<div className="block-outer friends">
        <div className="user">
            <Link className="link" to={`/home/profile/?p=${encodeURIComponent(username)}`}>
                <div className={`user-img ${isOwner ? "owner" : ""}`}>
                    {isOwner ? <img className="owner-badge" src={process.env.PUBLIC_URL + "/img/owner.png"} alt={meetoorOwner} /> : null}
                    <img className="img" src={photo} alt={branchText.alt.userPhoto} />
                </div>
                <div className="user-info">
                    <h1 dir="auto">
                        {name}
                    </h1>

                    {isSecure ? <div className="outer-state secure">
                        <SecureSvg className="lit" size={18} />
                        <h1 dir="auto">{messages.verifiedAcc}</h1>
                    </div> : null}
                </div>
            </Link>
        </div>
        <div className="outer-info">
            <div className="info">
                <JobSvg className="lit" size={18} />
                <span>{infos.job}</span>
            </div>
            <div className="info">
                <FollowersSvg className="lit" size={22} />
                <span>{compactNumber(infos?.followers, lang) + " " + badges.followers}</span>
            </div>
        </div>
        <div className="outer-tabs">
            <button className="tab grn" disabled={hold} onClick={addFollow}>
                {followState ? followState : <>
                    <AskFriendSvg className="lit" />
                    {buttons.follow}
                </>}
            </button>
            <button className="tab" disabled={hold} onClick={addFriend}>
                {isfriend === "sent" ? <>
                    <CloseSvg className="red" />
                    {buttons.cancel}
                </> : isfriend === false ? <>
                    <AskFriendSvg className="drk" />
                    {buttons.addFriend}
                </> : isfriend === "propa" ? <span className="propa">
                    <PropaMeetoor size={5} loading={true} clr="drk" />
                </span> : isfriend === true ? <>
                    <DeleteSvg className="red" />
                    {buttons.delete}
                </> : null}
            </button>
        </div>
    </div>)
}
////////////////////////////////////////////
const FollowingSuggest = memo(() => {
    const { messages, buttons, badges } = useSelector(state => state.sign.langData);
    const token = useSelector(state => state.sign.token);
    const data = useSelector(state => state.main.suggestFollowers);
    const dispatch = useDispatch();
    ////////////////////////////////////////
    const [hold, setHold] = useState(false);
    const [Scroll, setScroll] = useState(null);
    const [currenGet, setCurrenGet] = useState("myContacts/");
    ////////////////////////////////////////
    const getFollowerApi = async () => {
        try {
            const source = currenGet === "myContacts/" ? "contacts" : "people";
            const rows = await fetchFollowSuggestions(token, source);
            dispatch(Actions.type("setSuggestFollowers", {
                type: 'set',
                data: rows.sort(() => Math.random() - 0.5)
            }));
            Scroll && Scroll?.goTopSmooth();
        } catch (e) {
            console.log("Dashbord -> error.data", e)
            dispatch(Actions.type("setSuggestFollowers", { type: 'set', data: [] }));
        }
    }
    ////////////////////////////////////////
    useEffect(() => {
        getFollowerApi();
    }, [currenGet]);
    ////////////////////////////////////////
    return (<div className="branches-container popup">
        <div className="top-head-popup">
            <div className="info">{messages.followPopup.one}</div>
            <div className="info">{messages.followPopup.two}</div>
            <div className="redir">
                <button className={`btn-meetoor ${"myContacts/" === currenGet ? "active" : ""}`}
                    onClick={() => setCurrenGet("myContacts/")}>{badges.yourContacts}</button>
                <button className={`btn-meetoor ${"suggestFollow/" === currenGet ? "active" : ""}`}
                    onClick={() => setCurrenGet("suggestFollow/")}>{badges.peopleSuggest}</button>
            </div>
        </div>
        <ScrollBar detect={true}
            scrollRef={setScroll}>
            {(data === undefined) ?
                <PuffMeetoor size={100} loading={true} clr="drk" rev={true} />
                : data.length > 0 ? <>
                    {data.map((follow, i) => {
                        return (<BlockOuter
                            key={follow.username + i}
                            photo={follow.userPhoto}
                            name={follow.fullName}
                            userid={follow.userid}
                            infos={follow.infos}
                            isOwner={follow.isOwner}
                            isSecure={follow.isSecure}
                            setHold={setHold}
                            hold={hold}
                            isfriend={follow.isfriend}
                            followState={follow.followState}
                            username={follow.username} />)
                    })}
                </> :
                    <div className="noData-yet dark" style={{ "height": "350px" }}>
                        <div className="nodata">
                            <span>{messages.noFriends}</span>
                        </div>
                    </div>}
        </ScrollBar>
        <div className="top-head-popup bottom">
            <button className="buttons update"
                onClick={getFollowerApi}>
                {badges.update}
            </button>
            <button className="buttons" onClick={() => {
                dispatch(Actions.type("setPopupMain", false));
            }}>
                {buttons.continue}
            </button>
        </div>
    </div >)
})

export default FollowingSuggest;